import { render } from "./CadastroReceber.vue?vue&type=template&id=132ca398"
import script from "./CadastroReceber.vue?vue&type=script&lang=js"
export * from "./CadastroReceber.vue?vue&type=script&lang=js"

import "./CadastroReceber.vue?vue&type=style&index=0&id=132ca398&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__